<template>
  <div
    class="border-action-default-low border-l-action-brand-hi rounded-sm border border-l-6 px-24 py-16"
  >
    <div
      class="flex flex-col gap-8 md:flex-row md:items-center md:justify-between"
    >
      <div class="flex flex-col gap-4">
        <RevIllustration
          alt=""
          :height="27"
          sizes="82px"
          src="/img/insurance/backUpLogo.svg"
          :width="82"
        />

        <FormattedMessage
          class="body-2"
          :definition="translations.description"
          tag="p"
        >
          <template #deviceName>
            <span>{{ deviceName }}</span>
          </template>
        </FormattedMessage>
      </div>
      <div>
        <RevButton
          full-width="adaptive"
          size="small"
          variant="secondary"
          @click="browseOffers"
        >
          {{ i18n(translations.button) }}
        </RevButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAME } from '../../InsurancesV2.constants'

import translations from './Browse.translations'

const props = defineProps<{
  deviceName: string
  listingId: string
}>()

const i18n = useI18n()
const { trackClick } = useTracking()

function browseOffers() {
  trackClick({
    name: 'browse_insurance',
    zone: 'cart',
  })

  openModal(`${MODAL_NAME}_${props.listingId}`)
}
</script>
